<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oAqukv/tc-custom/9781947290228.jpg?1737330590389" alt="This image is the cover for the book Melia Ridge, The Max Blake Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Melia Ridge, The Max Blake Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>In the thrilling follow-up to <i>Emerald Ridge</i>, a PI and his fiancée head from Oregon to Rome—to find answers to mysteries both personal and political . . .</b><br/>  <br/> Max Blake’s fiancée, Caeli Brown, lost her archbishop uncle to gunfire—at least, that’s what they thought. So they’re puzzled when they receive another postcard from him. What’s going on? Is Uncle Jack dead or not?<br/>  <br/> Max and Caeli are soon on the road to the Vatican’s Secret Archives Building in the heart of Rome, where they meet a mysterious prelate with a fixation for world domination—a man who may well hold the key to determining who actually shot American President John F. Kennedy in 1963—in this gut-wrenching, surprising, and sharply witty tale of international mystery and intrigue.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Florence
      </h2>
      
      <p class="authorDescription body article">William Florence is the author of the Max Blake Mysteries series, which currently features: Raptor&rsquo;s Ridge, Misery Ridge, Faraway Ridge, Snowfall Ridge, and Emerald Ridge, and Melia Ridge. A former reporter, editor, and college professor, he worked at newspapers in Michigan, Washington, D.C., South Dakota, Indiana, and Oregon for 25 years and for 22 years as a journalism and writing instructor at a community college.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0226dda6